import React from "react";
import { Header, Container, Responsive } from "semantic-ui-react";
import SliderNavLandingPage from "../../components/SliderNavLandingPage";
import SliderFullWidthComponent from "../../components/SliderFullWidthComponent";

import DescripcionScreen from "../landingpagescreens/DescripcionScreen";
import PropiedadesScreen from "../landingpagescreens/PropiedadesScreen";
import ContactoScreen from "../landingpagescreens/ContactoScreen";

class LandingPageScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let amenitiesshow = [];
    if (
      this.props.data.amenities !== undefined &&
      this.props.data.amenities.length > 0
    ) {
      if (this.props.data.amenities.length < 4) {
        let indexGet = 0;
        while (amenitiesshow.length < 4) {
          if (indexGet >= this.props.data.amenities.length) {
            indexGet = 0;
          }
          amenitiesshow.push(this.props.data.amenities[indexGet]);
          indexGet = indexGet + 1;
        }
      } else {
        amenitiesshow = this.props.data.amenities;
      }
    }

    let imagesToShow = [];
    if (this.props.data.images !== undefined) {
      imagesToShow = this.props.data.images;
    }

    return (
      <div
        style={{
          overflow: "hidden"
        }}
      >
        <Container>
          <SliderNavLandingPage
            slider={amenitiesshow}
            amenities={this.props.data.amenitiesDesc}
          />
        </Container>
        <DescripcionScreen descData={this.props.data} />
        <PropiedadesScreen propData={this.props.data} url={this.props.url} />
        <SliderFullWidthComponent slider={imagesToShow} />
        <ContactoScreen propData={this.props.data} />
      </div>
    );
  }
}

export default LandingPageScreen;
